var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$apollo.loading)?_c('Loading'):_c('div',[_c('v-card-text',{staticStyle:{"height":"calc(100% - 52px)"},attrs:{"id":"endpoints-edit__card-text"}},[_c('Fields',{attrs:{"schema":{
        identifier: {
          label: 'Identificador del endpoint',
          type: 'string',
          description: 'No debe contener espacios, mayúsculas ni caracteres especiales además de - o _',
          fieldOptions: {
            color: _vm.accentColor,
            placeholder: 'crear-producto',
            validatePattern: '^[a-z0-9\-_]+$',
            validateCaseInsensitive: false,
            validateCustomError: 'No debe contener espacios, mayúsculas ni caracteres especiales además de - o _'
          },
          newDesign: true
        },
        name: {
          type: 'string',
          label: 'Nombre del endpoint',
          description: 'Debe ser único y reconocible',
          newDesign: true
        },
        type: {
          type: 'select',
          label: 'Tipo',
          fieldOptions: {
            options: _vm.endpointTypes
          },
          newDesign: true
        },
        requireToken: {
          type: 'boolean',
          label: 'Requiere Auth Token',
          optional: true,
          newDesign: true
        }
      },"disabled":_vm.$apollo.loading || _vm.saving,"environment-variables":{ environmentId: _vm.environmentId },"validationErrors":{}},model:{value:(_vm.endpoint),callback:function ($$v) {_vm.endpoint=$$v},expression:"endpoint"}}),_c('v-slide-y-transition',[(['view', 'list'].includes(_vm.endpoint.type))?_c('Fields',{key:"view",attrs:{"schema":{
          collectionId: {
            label: 'Colección',
            type: 'collectionSelect',
            newDesign: true
          },
          filterId: {
            type: 'filterSelect',
            label: 'Filtro',
            fieldOptions: {
              filterByKey: 'collectionId',
              filterByValue: _vm.endpoint.collectionId
            },
            newDesign: true
          },
        },"disabled":_vm.$apollo.loading || _vm.saving,"environment-variables":{ environmentId: _vm.environmentId },"validationErrors":{}},model:{value:(_vm.endpoint),callback:function ($$v) {_vm.endpoint=$$v},expression:"endpoint"}}):_vm._e(),(_vm.endpoint.type === 'indicator')?_c('Fields',{key:"view",attrs:{"schema":{
          indicatorId: {
            label: 'Indicador',
            type: 'indicatorSelect'
          },
          filterId: {
            type: 'filterSelect',
            label: 'Filtro'
          },
        },"disabled":_vm.$apollo.loading || _vm.saving,"environment-variables":{ environmentId: _vm.environmentId },"validationErrors":{}},model:{value:(_vm.endpoint),callback:function ($$v) {_vm.endpoint=$$v},expression:"endpoint"}}):_vm._e(),(_vm.endpoint.type === 'form')?_c('Fields',{key:"form",attrs:{"schema":{
          formId: {
            label: 'Formulario',
            type: 'formSelect'
          }
        },"disabled":_vm.$apollo.loading || _vm.saving,"environment-variables":{ environmentId: _vm.environmentId },"validationErrors":{}},model:{value:(_vm.endpoint),callback:function ($$v) {_vm.endpoint=$$v},expression:"endpoint"}}):_vm._e()],1),_c('v-slide-y-transition',[(_vm.endpoint.requireToken)?_c('div',[_c('h2',{staticClass:"headline"},[_vm._v("Tokens")]),_c('v-list',[_vm._l((_vm.endpoint.tokens),function(token){return _c('v-list-item',{key:token,attrs:{"href":"#"}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(token)}})],1),_c('v-list-item-action',[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.removeToken(token)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1)}),_c('v-list-item',{on:{"click":_vm.addToken}},[_c('v-list-item-avatar',[_c('v-icon',[_vm._v("add")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Generar Token")])],1)],1)],2)],1):_vm._e()])],1),_c('v-card-actions',[_c('v-btn',{attrs:{"text":"","icon":"","color":"error","disabled":_vm.$apollo.loading || _vm.saving,"title":"Eliminar Endpoint"},on:{"click":_vm.deleteItem}},[_c('v-icon',[_vm._v("delete")])],1),_c('v-btn',{attrs:{"text":"","icon":"","title":"Revertir Cambios","disabled":!_vm.dirty || _vm.saving},on:{"click":_vm.update}},[_c('v-icon',[_vm._v("undo")])],1),_c('v-flex'),_c('v-btn',{attrs:{"color":"#59a4f4","dark":"","disabled":_vm.$apollo.loading || _vm.saving},on:{"click":_vm.dismiss}},[_vm._v("Cancelar")]),_c('v-btn',{attrs:{"color":"#59a4f4","dark":!_vm.dirty ? false : true,"disabled":!_vm.dirty,"loading":_vm.$apollo.loading || _vm.saving},on:{"click":_vm.save}},[_vm._v("Guardar")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }